import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import './style.scss'
import { useEffect } from 'react';

export default function Dropdown(props) {
 
 
  const [value, setValue] = React.useState(props.value || '');

  const handleAutocompleteChange = (event,newValue)=>{
   setValue(newValue)
   props.onSelectValue(newValue)  
  }

  useEffect(() => {
    console.log("props",props); 
    setValue(props.value || ''); 
  }, [props.value])
  

  return (
    <Stack spacing={1} sx={{ width: 188 }} className="Policy-textfield">
      <Autocomplete
      // className="Policy-textfield"
        // {...defaultProps}
        // {...props.options}
        value={value}
        options={props.options}
        onChange={handleAutocompleteChange}
        id="select-on-focus"
        renderInput={(params) => (
          <TextField {...params}  label={props.label} variant={"filled"} />
        )}
      />
    </Stack>
  );
}
